import React from 'react';
import ReactPhoneNumberInput, { parsePhoneNumber } from 'react-phone-number-input';
import { useSelector } from 'react-redux';
import cn from 'classnames';

import { SUPPORTED_COUNTRIES } from 'bl/validation/validatePhone.bl';
import IP from 'constants/form/inputParser.const';
import useInputHelpers from 'hooks/useInputHelpers.hook';
import { selectCurrentSalonCountryCode } from 'selectors/currentSalon.selectors';
import { getIntlCountryCode } from 'utils/intl/locale.util';

import 'react-phone-number-input/style.css';

const CTAG = 'PhoneInput';

const PhoneInput = ({ onChange, name, value: valueFromProps, tag: tagFromProps, onFocus, onBlur, className, inputRef, ...props }) => {
  const countryCode = useSelector(selectCurrentSalonCountryCode);
  const { attributes, value, handle } = useInputHelpers(IP.text, valueFromProps, name, tagFromProps);

  const handleChange = (ev) => handle(`${CTAG}.onChange`, onChange, ev);

  const phoneCountryCode = value ? parsePhoneNumber(value)?.country : null;
  const intlCountryCode = getIntlCountryCode();
  const defaultCountry = phoneCountryCode || countryCode || intlCountryCode || 'GB';

  return (
    <ReactPhoneNumberInput
      {...attributes}
      className={cn(className)}
      addInternationalOption
      countries={SUPPORTED_COUNTRIES}
      defaultCountry={defaultCountry}
      onChange={handleChange}
      value={value}
      inputRef={inputRef}
      {...props}
    />
  );
};

export default PhoneInput;
